var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 47,
    viewBox: "0 0 52 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_104_1539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30589 38.2574C6.58467 38.2574 6 37.6727 6 36.9515V26.7904C6 23.959 6.28313 21.2693 6.8494 18.7211C7.51005 16.1728 8.54821 13.6718 9.96389 11.218C11.2984 9.0494 12.9646 6.91768 14.9625 4.82281C15.4171 4.34622 16.1583 4.30147 16.6781 4.70581L20.971 8.0447C21.591 8.52695 21.6464 9.44218 21.1097 10.0157C18.8333 12.4482 17.2416 14.7365 16.3344 16.8807C15.6422 18.6806 15.2038 20.5312 15.0193 22.4327C14.9372 23.2787 13.9391 23.7556 13.2708 23.2305C12.5101 22.6328 12.9327 21.4108 13.9001 21.4108H21.5406C22.2619 21.4108 22.8465 21.9955 22.8465 22.7167V36.9515C22.8465 37.6727 22.2619 38.2574 21.5406 38.2574H7.30589ZM30.4594 38.2574C29.7382 38.2574 29.1535 37.6727 29.1535 36.9515V26.7904C29.1535 23.959 29.4366 21.2693 30.0029 18.7211C30.6635 16.1728 31.7017 13.6718 33.1174 11.218C34.4519 9.0494 36.1181 6.91768 38.116 4.82281C38.5705 4.34622 39.3117 4.30147 39.8316 4.70581L44.1245 8.0447C44.7445 8.52695 44.7999 9.44218 44.2632 10.0157C41.9868 12.4482 40.3951 14.7365 39.4879 16.8807C38.7956 18.6806 38.3573 20.5312 38.1728 22.4327C38.0907 23.2787 37.0926 23.7556 36.4242 23.2305C35.6636 22.6328 36.0862 21.4108 37.0536 21.4108H44.6941C45.4153 21.4108 46 21.9955 46 22.7167V36.9515C46 37.6727 45.4153 38.2574 44.6941 38.2574H30.4594Z",
    fill: "#FECE2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_104_1539",
    x: 0,
    y: 0.431641,
    width: 52,
    height: 45.8262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.807843 0 0 0 0 0.184314 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_1539"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_1539",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.03f33fcdfe641314448cf35a11e6e03a.svg";
export { ForwardRef as ReactComponent };